import { useState } from "react";
import ChevronDown from "../icons/ChevronDown";
import { CompetencyDetailSmallModal } from "./CompetencyDetailSmallModal";
import { Competency, LearnerOutcome } from "@/lib/models";

type CompetencyDetailSmallNavigationProps = {
  className?: string;
  competency?: Competency;
  learnerOutcome: LearnerOutcome;
  changeCompetency: (competencyId: string) => Promise<void>;
};
export const CompetencyDetailSmallNavigation = ({
  className,
  learnerOutcome,
  competency,
  changeCompetency,
}: CompetencyDetailSmallNavigationProps) => {
  const [showModal, setShowModal] = useState(false);

  const handleModal = () => {
    setShowModal(!showModal);
  };

  return (
    <div>
      {showModal && (
        <div>
          <CompetencyDetailSmallModal
            className="absolute z-50 w-[328px] medium:hidden"
            learnerOutcome={learnerOutcome}
            activeCompetency={competency}
            changeCompetency={changeCompetency}
            handleModal={handleModal}
          />
          <div
            className="fixed left-0 right-0 top-0 z-40 h-full w-full bg-black bg-opacity-70 medium:hidden"
            onClick={handleModal}
            aria-hidden="true"
          ></div>
        </div>
      )}
      <button
        className={`${className} mb-6 inline-flex h-12 w-[328px] items-center justify-between rounded-full border border-solid border-stone-200 bg-white px-4 py-3 font-roobert text-base font-medium leading-none`}
        onClick={handleModal}
        aria-label="Select Competency Dropdown"
      >
        <span>Select a Competency...</span>
        <ChevronDown />
      </button>
    </div>
  );
};
